import Vue from 'vue'
import Vuex from 'vuex'
import main from './modules/main'
import echarts from './modules/echarts'
import courier from "@/store/modules/courier";
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    userName: '',
    loginName: '',
    portalHtml: '',
    products: {}

  },
  mutations: {
    createUserName (state, info) {
      state.userName = info
    },
    createPortalHtml (state, info) {
      state.portalHtml = info
    },
    setProducts (state, info) {
      state.products = info
    }

  },
  getters: {
    getUserName (state) {
      return state.userName
    },
    getPortalHtml (state) {
      return state.portalHtml
    }

  },
  actions: {

  },
  modules: {
    main, echarts,courier
  }
})
